import { Box, Breadcrumbs, Button, Typography } from '@material-ui/core'
// import { AssignmentInd } from '@material-ui/icons';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { EnumTipoSujeto } from '../../api'
import Page from '../../components/page/page'
import PageHeader from '../../components/page/pageHeader'
import { BreadcrumbLink } from '../../components/shared/breadcrumbLink/breadcrumbLink'
import { usePageState } from '../../hooks'
import { GlobalNotification, NonAuthRoutes } from '../../model'
import { fetchClientDataByID } from '../../redux'
import { selectClientData } from '../../redux/selectors/client.selectors'
import { getLinkClientText } from '../clients/client.helper'
import { ContactsInfoTable } from './components/contactsInfoTable'

export const ContactsInfoPage: React.FC<any> = props => {
  const [t] = useTranslation(['contactsInfo', 'globalerisLibrary', 'enums'])

  const history = useHistory()
  const [isFetching, setIsFetching] = useState<boolean>(false)
  const { dataTableFilter, dataTableSearch } = usePageState()

  const [globalNotification, setGlobalNotification] = useState<GlobalNotification | undefined>(
    undefined
  )
  const [clientID] = useState<number>(
    props.location.state !== undefined ? props.location.state.id : 0
  )
  const [subjectType] = useState<EnumTipoSujeto>(
    props.location.state !== undefined
      ? props.location.state.subjectType
      : EnumTipoSujeto.ClienteFinal
  )
  const clientData = useSelector(selectClientData)
  const [clientUpdated, setClientUpdated] = useState<boolean>(true)

  // Handlers Region Starts
  const onTableFetching = (childIsFetching: boolean) => {
    setIsFetching(childIsFetching)
  }
  // Handlers Region Ends

  return (
    <Page notification={globalNotification}>
      <PageHeader title={t('contactsInfo:title')}>
        <Button
          color="primary"
          size="small"
          disabled={isFetching}
          onClick={() => {
            // history.push(NonAuthRoutes.Client)
            !clientUpdated && clientID && fetchClientDataByID(clientID)
            clientID
              ? history.push(NonAuthRoutes.ClientFile, { clientID })
              : history.push(NonAuthRoutes.Client)
          }}
        >
          {t('contactsInfo:buttons.back')}
        </Button>
      </PageHeader>
      <Box mb={1} ml={2}>
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          {clientData && (
            <BreadcrumbLink
              toPathName="/client/file"
              state={{ clientID: clientData.id }}
            >{`Cliente ${getLinkClientText(clientData)} - ID ${
              clientData.documentID
            }`}</BreadcrumbLink>
          )}
          <Typography key="3" color="primary" variant="subtitle1">
            {t('contactsInfo:title')}
          </Typography>
        </Breadcrumbs>
      </Box>
      <ContactsInfoTable
        clientID={clientID}
        dataTableFilter={dataTableFilter}
        dataTableSearch={dataTableSearch}
        onFetching={onTableFetching}
        setNeedUpdateClient={() => setClientUpdated(false)}
      ></ContactsInfoTable>
    </Page>
  )
}
